/**
 * Copyright (c) 2024 Securisea, Inc.
 * All rights reserved.
 *
 * This is unpublished, propriety, internal
 * source code of Securisea, Inc.
 * No license is provided to any third parties.
 * If found outside of a Securisea, Inc. environment
 * report to bounty@securisea.com for a possible cash reward
 * and promptly delete all files.
 */
import React from "react";
import { RouterProvider } from "react-router-dom";
import theme from "./theme";
import { router } from "./routes";
import { ThemeProvider } from "@emotion/react";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import "./index.css";

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <ToastContainer position="top-right" autoClose={3500} />
      <RouterProvider router={router} />
    </ThemeProvider>
  );
};

export default App;
